import { Box, Typography } from '@mui/material';
import { hideBelowSx } from '../collapse';
import {
  TITLE_FLEX,
  VALUE_WIDTH,
  type LedgerCollapse,
  type LedgerColumn,
} from '../types';

export interface LedgerHeaderProps {
  columns: readonly LedgerColumn[];
  collapse: LedgerCollapse;
  /** Label over the title cell. */
  titleLabel?: string;
  valueLabel?: string;
  showValues?: boolean;
}

/** Column headings, honouring the same collapse point and value toggle as rows. */
export const LedgerHeader = ({
  columns,
  collapse,
  titleLabel = 'Work',
  valueLabel = 'Value',
  showValues = true,
}: LedgerHeaderProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      px: 2,
      py: 0.75,
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Box sx={{ flex: `${TITLE_FLEX} 1 0`, minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" fontWeight={500}>
        {titleLabel}
      </Typography>
    </Box>
    {columns.map(column => (
      <Box
        key={column.key}
        sx={{
          flex: `${column.flex} 1 0`,
          minWidth: 0,
          ...hideBelowSx(collapse),
        }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight={500}>
          {column.label}
        </Typography>
      </Box>
    ))}
    {showValues && (
      <Box sx={{ width: VALUE_WIDTH, flexShrink: 0, textAlign: 'right' }}>
        <Typography variant="caption" color="text.secondary" fontWeight={500}>
          {valueLabel}
        </Typography>
      </Box>
    )}
  </Box>
);
